export default "<p>\n  exercise-secuence-constructor works!\n</p>\n";